import React from "react";
import { Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

// Category selection buttons
export const CategorySelection = ({
  category,
  handleCategorySelect,
  handleReset,
  t,
}) => {
  // const { t } = useTranslation();

  const categories = [
    "substitution_de_matiere_grasse",
    "selection_des_antimicrobiens",
    "substitution_des_sucres",
    "selection_des_antioxydants",
    "selection_des_emulsifiants",
    "selection_des_moussants",
    "selection_des_epaississants"
  ];

  return (
    <Box display="flex" gap={2} marginBottom={2}>
      {categories.map((cat) => (
        <Button
          key={cat}
          variant="contained"
          disabled={category && category !== cat}
          onClick={() => handleCategorySelect(cat)}
        >
          {t(`dashboard.decision-tree.categories.${cat}`)}
        </Button>
      ))}
      {category && (
        <Button variant="outlined" color="secondary" onClick={handleReset}>
          Reset
        </Button>
      )}
    </Box>
  );
};

export default CategorySelection;
